import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-430cd6fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "document-item" }
const _hoisted_2 = { class: "info-title" }
const _hoisted_3 = { class: "info-description" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"guide-subtitle\" data-v-430cd6fa><span class=\"guide-border\" data-v-430cd6fa></span>请求地址 </div><div class=\"info-url\" data-v-430cd6fa><a style=\"text-decoration:none;color:rgb(30, 115, 241);display:inline-block;word-break:break-all;line-height:1.5;\" target=\"_blank\" data-v-430cd6fa>https://xxxxxxxxxxxxxxxxxxxxxxx</a></div><div style=\"margin:20px 0px;\" data-v-430cd6fa><p style=\"margin-bottom:10px;line-height:30px;letter-spacing:1.2px;color:#5a5a5a;\" data-v-430cd6fa> 支持http和https协议。请求方式GET，请求协议application/xml或application/json，对应XML和JSON两种返回格式。若您想通过上述地址查看两种返回格式的区别，可点击下方按钮切换： </p></div><div class=\"info-subtitle\" data-v-430cd6fa>请求参数</div><table class=\"info-params\" data-v-430cd6fa><tr data-v-430cd6fa><th data-v-430cd6fa>参数</th><th data-v-430cd6fa>类型</th><th data-v-430cd6fa>必填</th><th data-v-430cd6fa>说明</th></tr><tr data-v-430cd6fa><td data-v-430cd6fa>xxxx</td><td data-v-430cd6fa>xxxxx</td><td data-v-430cd6fa>xxxxxx</td><td data-v-430cd6fa>xxxx</td></tr></table>", 5)

import { ref, watch } from "vue";
import { useRouter, useRoute } from "vue-router";
import Data from "./data.js";

export default /*#__PURE__*/_defineComponent({
  __name: 'details',
  props: { parameterArr: String },
  setup(__props) {

const parameterArr = __props;


// const menuData = defineProps({ menuData: Array });
const route = useRoute();
const apiName = ref();
const description = ref();
const resExample = ref();
resExample.value =
  '{\n    "status": 0,\n    "result": {\n        "location": {\n            "areacode": "101010100",\t//高分城市ID\n            "name": "北京",\t\t//城市中文名\n            "country": "中国",\t\t//所属国家中文名\n            "path": "北京,北京市,北京市,中国"    //行政区划路径\n        },\n        "realtimeAqi": {\n            "aqi": 124,\t\t\t//空气质量指数\n            "aqi_level": "轻度污染",\t//空气质量等级\n            "pm10": 59,\t\t//PM10浓度，单位: 微克/立方米\n            "pm25": 94,\t\t//PM2.5浓度，单位: 微克/立方米\n            "no2": 18,\t\t\t//二氧化氮浓度，单位: 微克/立方米\n            "so2": 3,\t\t\t//二氧化硫浓度，单位: 微克/立方米\n            "co": 1.0,\t\t\t//一氧化碳浓度，单位: 毫克/立方米\n            "o3": 36,\t\t\t//臭氧浓度，单位: 微克/立方米\n            "pollutant": "一氧化碳",\t//首要污染物，有时为空\n            "data_time": "2020-02-14 09:00:00",\t//实况数据时间\n            "stations": [\n                {\n                    "stationID": "1011A",\t//站点编号\n                    "lon": 116.73,\t\t//站点经度\n                    "lat": 39.68,\t\t//站点纬度\n                    "name": "永定门",\t\t//站点名称\n                    "aqi": 68,\t\t\t//实时空气质量指数\n                    "aqi_level": "良",\t\t//空气质量等级\n                    "pm10": 0,\t\t\t//PM10浓度，单位: 微克/立方米\n                    "pm25": 49,\t\t//PM2.5浓度，单位: 微克/立方米\n                    "no2": 27,\t\t\t//二氧化氮浓度，单位: 微克/立方米\n                    "so2": 2,\t\t\t//二氧化硫浓度，单位: 微克/立方米\n                    "co": 1.0,\t\t\t//一氧化碳浓度，单位: 毫克/立方米\n                    "o3": 30,\t\t\t//臭氧浓度，单位: 微克/立方米\n                    "pollutant": "细颗粒物(PM2.5)",\t//首要污染物，有时为空\n                },\n\t            ……\t\t\t\t//其它站点实况信息\n            ]\n        }\n        "last_update": "2020-02-14 09:44:00",\t//数据更新时间\n    }\n}';

const changeApiName = (val: any) => {
  for (const i in Data) {
    if (val[0] == Data[i].id) {
      for (let j in Data[i].data) {
        if (val[1] == Data[i].data[j].id) {
          apiName.value = Data[i].data[j].name;
          description.value = Data[i].data[j].description;
        }
      }
    }
  }
};
watch(
  () => route.params,
  (val: string) => {
    changeApiName([val.menuid, val.menuitemid]);
  },
  { immediate: true, deep: true }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(apiName.value), 1),
        _createElementVNode("div", _hoisted_3, _toDisplayString(description.value), 1)
      ]),
      _hoisted_4
    ])
  ]))
}
}

})